import { translate } from "@kaltura/ds-react-utils";
import { FieldTypeOption } from "@kaltura/mediaspace-shared-types";
import { AutocompleteField } from "../../autocomplete-field/AutocompleteField";

export interface TimezonesProps {
    timezones: FieldTypeOption[];
    /**
     * Optional field name prefix for form field namespacing
     */
    fieldPrefix?: string;

    /**
     * if true, inputs are disabled
     */
    disabled?: boolean;

    /**
     * ID of the element that describes this section for accessibility
     */
    "aria-describedby"?: string;
}

const Timezones = ({
    timezones,
    fieldPrefix = "",
    disabled = false,
    "aria-describedby": ariaDescribedBy,
}: TimezonesProps) => {
    const fieldName = fieldPrefix ? `${fieldPrefix}.tz` : "tz";

    return (
        <AutocompleteField
            inline={true}
            id={fieldName}
            label={translate("Time zone")}
            options={timezones}
            disabled={disabled}
            aria-describedby={ariaDescribedBy}
            fontWeightBold={true}
        />
    );
};

export default Timezones;
